// Static coach data — edit here instead of the database.
// photoKey and instagramUrl: fill from DB (SELECT name, photoKey, instagramUrl FROM coaches WHERE isActive='yes')
export interface Coach {
  id: number;
  name: string;
  title: string;
  bio: string;
  photoKey?: string;
  instagramUrl?: string;
}

export const COACHES: Coach[] = [
  {
    id: 1,
    name: "Gaspar Plaza",
    title: "Cirujano Ortopédico · Medicina Deportiva",
    bio: "Cirujano ortopédico y traumatólogo especializado en Cirugía Ortopédica y Traumatología y en Ciencias del Deporte, con 15 años de experiencia en medicina deportiva, técnicas artroscópicas y terapias biológicas avanzadas. Su formación internacional incluye fellowships en Estados Unidos y cirugía asistida por robot. Es médico en la Unidad de Rodilla del CHUA, docente en la Facultad de Medicina de Albacete y colaborador docente en la cátedra de Cirugía de la UCAM. En Golf Motion Lab aporta el criterio médico que respalda cada valoración: un diagnóstico preciso de la lesión y de su origen, para que el plan de entrenamiento parta siempre de un cuerpo bien entendido y proteja tu salud en el campo.",
    photoKey: "/img/gaspar-web_a84feed5.jpg",
    instagramUrl: "https://www.instagram.com/plaza_traumatologia/",
  },
  {
    id: 2,
    name: "Sergio Sánchez",
    title: "Fisioterapeuta · Rehabilitación y Rendimiento",
    bio: "Fisioterapeuta especializado en rehabilitación y rendimiento, con más de 10 años de experiencia en entornos deportivos de alto rendimiento. Ha formado parte de cuerpos técnicos de equipos deportivos, trabajando en rehabilitación, recuperación y rendimiento con atletas de élite. Su formación internacional abarca biomecánica del movimiento, entrenamiento de fuerza y prescripción del ejercicio, control motor y gestión de cargas. En Golf Motion Lab trae toda esa experiencia del deporte profesional al golf: valorando el cuerpo con precisión, identificando qué limita tu swing y diseñando un plan que convierte los datos en mejoras reales sobre el campo.",
    photoKey: "/img/sergio-web_8c02a944.jpg",
    instagramUrl: "https://www.instagram.com/sergiosama_/",
  },
  {
    id: 3,
    name: "Aitor Pardo",
    title: "Director Técnico · Especialista en Swing",
    bio: "Jugador profesional y Técnico Deportivo de Nivel 1 certificado por la Real Federación Española de Golf. TPI Certified y Professional Clubfitter, ejerce como Director Técnico de la Federación de Golf de Castilla-La Mancha. Entrena a jugadores profesionales que compiten en el Alps Tour, el Challenge Tour y PGA España. En Golf Motion Lab aporta el análisis experto de la cinemática del swing, estudiando cada detalle de la secuencia y traduciendo los datos del laboratorio en decisiones técnicas que el jugador puede aplicar desde la primera sesión.",
    photoKey: "/img/aitor-web_0b0e8621.jpg",
    instagramUrl: "https://www.instagram.com/aitor_pardo_golf_coach/",
  },
];
